var e = /* @__PURE__ */ ((r) => (r.error = "error", r.idle = "idle", r.loading = "loading", r.success = "success", r))(e || {});
export {
  e as STATUS
};
//# sourceMappingURL=status.es.js.map
